import UIAlert from 'UIComponents/alert/UIAlert';
import I18n from 'I18n';
import { connect } from 'react-redux';
import { hideTokenExpiredAlert as hideTokenExpiredAlertAction } from '../../actions';
import { getIsTokenExpiredAlertVisible } from '../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
const TokenExpiredAlert = ({
  isTokenExpiredAlertVisible,
  hideTokenExpiredAlert
}) => {
  if (!isTokenExpiredAlertVisible) {
    return /*#__PURE__*/_jsx("div", {});
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: I18n.text('login.twoFactor.errors.tokenExpired.title'),
    closeable: true,
    onClose: hideTokenExpiredAlert,
    children: I18n.text('login.twoFactor.errors.tokenExpired.body')
  });
};
const mapStateToProps = state => ({
  isTokenExpiredAlertVisible: getIsTokenExpiredAlertVisible(state)
});
export default connect(mapStateToProps, {
  hideTokenExpiredAlert: hideTokenExpiredAlertAction
})(TokenExpiredAlert);